import { render, staticRenderFns } from "./DisplayWebshop.vue?vue&type=template&id=0103a400&scoped=true&"
import script from "./DisplayWebshop.vue?vue&type=script&lang=js&"
export * from "./DisplayWebshop.vue?vue&type=script&lang=js&"
import style0 from "./DisplayWebshop.vue?vue&type=style&index=0&id=0103a400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0103a400",
  null
  
)

export default component.exports